export enum Role {
  User = 'USER',
  TeamLeader = 'TEAM_LEADER',
  DiamondLeader = 'DIAMOND_LEADER',
  Administrator = 'ADMIN',
}
